import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-end gap-2 px-3 py-2" }
const _hoisted_2 = ["placeholder"]
const _hoisted_3 = ["disabled"]

import { computed, ref } from 'vue'
import GlowFrame from '@/components/catering/GlowFrame.vue'
import { composerCanSend, enterToSend } from '@/helpers/botComposer'


export default {
  __name: 'BotComposer',
  props: {
  disabled: { type: Boolean, default: false },
  placeholder: { type: String, default: 'Ask about your catering store…' }
},
  emits: ['submit'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit
const text = ref('')
const focused = ref(false)
const canSend = computed(() => composerCanSend(text.value))
const send = () => {
  if (props.disabled || !canSend.value) return
  emit('submit', text.value.trim())
  text.value = ''
}
const onKeydown = e => {
  if (enterToSend(e) === 'send') {
    e.preventDefault()
    send()
  }
}

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(GlowFrame, {
    interactive: "",
    focused: focused.value
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["relative rounded-catering-lg border-[1.5px] bg-catering-cream-50 shadow-catering-sm transition-colors duration-300", focused.value ? 'border-catering-honey-500/40' : 'border-catering-cream-300'])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((text).value = $event)),
            placeholder: __props.placeholder,
            rows: "1",
            "aria-label": "Message Bottle Bot",
            class: "block max-h-32 w-full flex-1 resize-none border-none bg-transparent text-catering-base text-catering-ink-900 outline-none focus:ring-0 placeholder:text-catering-ink-400",
            onFocus: _cache[1] || (_cache[1] = $event => (focused.value = true)),
            onBlur: _cache[2] || (_cache[2] = $event => (focused.value = false)),
            onKeydown: onKeydown
          }, null, 40, _hoisted_2), [
            [_vModelText, text.value]
          ]),
          _createElementVNode("button", {
            type: "button",
            disabled: __props.disabled || !canSend.value,
            class: "shrink-0 rounded-catering-md bg-catering-ink-900 px-3 py-1.5 text-sm font-semibold text-catering-lemon disabled:opacity-40",
            onClick: send
          }, " Send ", 8, _hoisted_3)
        ])
      ], 2)
    ]),
    _: 1
  }, 8, ["focused"]))
}
}

}